import { render, staticRenderFns } from "./RegisterMonthlyDoc.vue?vue&type=template&id=18af2390&"
import script from "./RegisterMonthlyDoc.vue?vue&type=script&lang=js&"
export * from "./RegisterMonthlyDoc.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMonthlyDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports